import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { adminBaseUrl } from "../routes";
import { headerWithAuthToken } from "../headers";
import { assignJob, deleteJob, getAllJobs, getSingleJob, updateJob } from "./queries";

const jobsApi = createApi({
  reducerPath: "jobsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: adminBaseUrl,
    prepareHeaders: headerWithAuthToken,
  }),
  endpoints: (builder) => ({
    // get all users
    getAllJobs: builder.query({
      providesTags: ["all_jobs"],
      query: getAllJobs,
    }),

    // get single user
    getSingleJob: builder.query({
      providesTags: ["job"],
      query: getSingleJob,
    }),

    //assign job
    assignJob: builder.mutation({
      providesTags: ["assgin_job"],
      query: assignJob,
    }),

    //assign job
    deleteJob: builder.mutation({
      providesTags: ["all_jobs"],
      query: deleteJob,
    }),

    //update job
    updateJob: builder.mutation({
      providesTags: ["update_job"],
      query: updateJob,
    }),
  }),
});

export const {
  useGetAllJobsQuery,
  useGetSingleJobQuery,
  useAssignJobMutation,
  useUpdateJobMutation,
  useDeleteJobMutation,
  reducer: jobsApiReducer,
  reducerPath: jobsApiReducerPath,
  middleware: jobsApiMiddleWare,
} = jobsApi;
